import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlayArrowIcon(props: IconProps) {
    return <Icon {...props} iconKey={"play_arrow"}/>
}
